import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import HoverTooltip from '@Components/HoverTooltip';
import StructureToolbarOptionsContent from '@Components/Results/structure/StructureToolbarOptionsContent';

import './StructureToolbarOptions.scss';

export default function StructureToolbarOptions(props) {
  const { onOpen, tooltipId, tooltipPlace } = props;
  const tooltipLabel = 'View Options';
  const toggleMenu = useCallback(
    (isOpen) => {
      if (isOpen) {
        const tooltip = document.getElementById(tooltipId);
        if (tooltip) {
          tooltip.dispatchEvent(
            new MouseEvent('mouseleave', {
              bubbles: true,
            })
          );
        }
        onOpen();
      }
    },
    [onOpen]
  );

  return (
    <Flyout
      className="structure-toolbar-options"
      flyout={
        <div className="u-els-nowrap">
          <div className="u-els-margin-bottom u-els-font-size-h4 toolbar-options-label">Options</div>
          <StructureToolbarOptionsContent {...props} />
        </div>
      }
      shouldCloseOnESC
      showCloseButton
      onToggle={toggleMenu}
      placement="bottom-end"
      pointerType="primary">
      <HoverTooltip id={tooltipId} tooltip={tooltipLabel} place={tooltipPlace} theme="simple">
        <button
          type="button"
          aria-label="View options"
          onClick={toggleMenu}
          title={tooltipId ? null : tooltipLabel}
          className="els-btn els-btn-link els-btn-sm structure-options-button e2e-dropdown e2e-options">
          <svg className="els-btn-icon els-btn-icon-sm" focusable="false">
            <use xlinkHref="#icon-ellipsis" />
          </svg>
          <span className="screen-reader-text">Options</span>
        </button>
      </HoverTooltip>
    </Flyout>
  );
}

StructureToolbarOptions.defaultProps = {
  onOpen: () => null,
  onItemClick: () => null,
  onOpenInDatabaseOptionClick: () => null,
  onAutoSynthesizeOptionClick: () => null,
};

StructureToolbarOptions.propTypes = {
  synthesisOptions: PropTypes.array,
  optionsIcon: PropTypes.string,
  context: PropTypes.object,
  metadata: PropTypes.object,
  onToggleMenu: PropTypes.func,
  onOpen: PropTypes.func,
  onItemClick: PropTypes.func,
  onOpenInDatabaseOptionClick: PropTypes.func,
  onAutoSynthesizeOptionClick: PropTypes.func,
  tooltipId: PropTypes.string,
  tooltipPlace: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};
